import React, {useContext, useState, useEffect, useMemo, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, useLocation} from "react-router-dom";
import {Tab, Tabs} from '../../components/common/TabCustom';

import { ALERT_TYPE, EMISION_EJECUCION_STATE, MASK_FORMAT, OPERATION_MODE, PROCESO_STATE, REQUEST_METHOD, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet } from '@laramie/ui';
import {APIS} from '../../config/apis';
import {ServerRequest} from '../../utils/apiweb';
import { useEntidad, useForm, useNav, useUnsavedChangesGuard, useFormErrors } from '../../components/hooks';

import {
    Loading,
    SectionHeading,
    InputFormat,
    InputEntidad,
    InputEjercicio,
    DatePickerCustom,
    InputLista,
    TableCustom,
    InputNumber,
    Accordion,
    CheckboxButton,
    CheckboxButtonGroup,
    FormError,
    FormLabel
} from '../../components/common';
import {VALIDATION_MESSAGE} from '../../consts/validationMessage';
import {FooterButtonVolver} from '../../components/buttons/FooterButtonVolver/FooterButtonVolver';
import {CloneObject} from '../../utils/helpers';
import {getDateId, getDateNow, getDateToString, getFormatNumber, iif} from '../../utils/convert';
import DataTaggerFormRedux from '../../components/controls/DataTaggerFormRedux';
import ProcedimientoParametrosGrid from '../../components/controls/ProcedimientoParametrosGrid';
import EmisionEjecucionCuotasGrid from '../../components/controls/EmisionEjecucionCuotasGrid';
import EmisionEjecucionCuentasGrid from '../../components/controls/EmisionEjecucionCuentasGrid';
import EmisionAprobacionesGrid from '../../components/controls/EmisionAprobacionesGrid';
import EmisionProcesosGrid from '../../components/controls/EmisionProcesosGrid';
import {useAccess} from '../../components/hooks/useAccess';
import {APPCONFIG} from '../../app.config';
import {ManagedContext} from '../../context/custom';
import {TIPS} from "../../consts/tips";

function EmisionEjecucionView() {

    //parametros url
    const params = useParams();
    const location = useLocation();
    const filters = location.state?.filters;
    const {showMessageModal} = useContext(ManagedContext)
    const [countProcessPendings, setCountProcessPendings] = useState(0);

    //variables
    const entityInit = {
        emisionDefinicion: {
            id: 0,
            idTipoTributo: 0,
            idNumeracion: 0,
            idProcedimiento: 0,
            idEstadoEmisionDefinicion: 0,
            idEmisionDefinicionBase: 0,
            idBoletaDefinicion: 0,
            numero: '',
            descripcion: '',
            codigoDelegacion: '',
            periodo: '',
            procesaPlanes: false,
            procesaRubros: false,
            procesaCarteles: false,
            procesaElementos: false,
            partidaUnificada: false,
            calculoMostradorWeb: false,
            calculoMasivo: false,
            calculoPagoAnticipado: false,
            fechaReliquidacionDesde: null,
            fechaReliquidacionHasta: null,
            modulo: ''
        },
        emisionEjecucion: {
            id: 0,
            idEmisionDefinicion: 0,
            idEstadoEmisionEjecucion: 0,
            idEmisionEjecucionAdelantada: 0,
            numero: '',
            descripcion: '',
            descripcionAbreviada: '',
            descripcionNotificacion: '',
            periodo: '',
            imprimeRecibosEmision: false,
            aplicaDebitoAutomatico: false,
            calculoMostradorWeb: false,
            calculoMasivo: false,
            calculoPrueba: false,
            calculoPagoAnticipado: false,
            fechaPagoAnticipadoVencimiento1: null,
            fechaPagoAnticipadoVencimiento2: null,
            fechaEjecucionInicio: null,
            fechaEjecucionFin: null,
            idOrdenamientoGeneral: 0,
            cuota: 0
        },
        emisionAprobacion: {
            id: 0,
            idEmisionEjecucion: 0,
            idEstadoProcesoInformeCalculo: 0,
            idUsuarioProcesoInformeCalculo: 0,
            fechaProcesoInformeCalculo: null,
            idEstadoProcesoControlRecibos: 0,
            idUsuarioProcesoControlRecibos: 0,
            fechaProcesoControlRecibos: null,
            idEstadoAprobacionCalculo: 0,
            idUsuarioAprobacionCalculo: 0,
            fechaAprobacionCalculo: null,
            idEstadoAprobacionControlRecibos: 0,
            idUsuarioAprobacionControlRecibos: 0,
            fechaAprobacionControlRecibos: null,
            idEstadoProcesoOrdenamiento: 0,
            idUsuarioProcesoOrdenamiento: null,
            fechaProcesoOrdenamiento: null,
            idEstadoProcesoInformeOrdenamiento: 0,
            idUsuarioProcesoInformeOrdenamiento: null,
            fechaProcesoInformeOrdenamiento: null,
            idEstadoAprobacionOrdenamiento: 0,
            idUsuarioAprobacionOrdenamiento: 0,
            fechaAprobacionOrdenamiento: null,
            idEstadoAprobacionCodigoBarras: 0,
            idUsuarioAprobacionCodigoBarras: 0,
            fechaAprobacionCodigoBarras: null,
            idEstadoProcesoCuentaCorriente: 0,
            idUsuarioProcesoCuentaCorriente: 0,
            fechaProcesoCuentaCorriente: null,
            idEstadoProcesoPublicacionDeuda: 0,
            idUsuarioProcesoPublicacionDeuda: 0,
            fechaProcesoPublicacionDeuda: null,
            idEstadoProcesoArchivoPublicacionDeuda: 0,
            idUsuarioProcesoArchivoPublicacionDeuda: null,
            fechaProcesoArchivoPublicacionDeuda: null,
            idEstadoProcesoImpresion: 0,
            idUsuarioProcesoImpresion: 0,
            fechaProcesoImpresion: null,
            idEstadoProcesoNotificacion: 0,
            idUsuarioProcesoNotificacion: 0,
            fechaProcesoNotificacion: null
        },
        procedimiento: {
            id: 0,
            nombre: '',
            descripcion: '',
            modulo: '',
            procedimientoParametros: [],
            procedimientoVariables: []
        },
        archivos: [],
        observaciones: [],
        etiquetas: [],
        funciones: [],
        emisionVariables: [],
        emisionProcedimientoParametros: [],
        emisionCuotas: [],
        emisionEjecucionCuotas: []
    }
    const procesoInit = {
        id: 0,
        identificador: "",
        entidad: "",
        idEntidad: 0,
        idProcesoProgramacion: 0,
        idEstadoProceso: 0,
        idCategoriaProceso: 0,
        idTipoProceso: 0,
        fechaProceso: null,
        fechaInicio: null,
        fechaFin: null,
        descripcion: "",
        observacion: "",
        avance: 0,
        origen: "",
        idUsuarioCreacion: "",
        fechaCreacion: null,
        urlEjecucion: "",
        temporal: false,
        cancelacionSolicitada: false,
        cancelable: false,
        pausable: false
    }

    //#region Hooks
    const navigate = useNav()

    const [state, setState] = useState({
        processKey: `EmisionEjecucion_${params.id ?? 0}_${getDateId()}`,
        id: params.id ? parseInt(params.id) : 0,
        mode: params.mode,
        loading: false,
        entity: entityInit,
        tabActive: "procedimiento"
    });
    const [timestampUpdateVariables, setTimestampUpdateVariables] = useState(null);
    const [pendingChange, setPendingChange] = useState(false);
    const [datosOpen, setDatosOpen] = useState(true);
    const [parametrosOpen, setParametrosOpen] = useState(false);
    const [listEmisionEjecucionCuentaResume, setListEmisionEjecucionCuentaResume] = useState([]);
    const [listCuotas, setListCuotas] = useState([]);
    const [processSpeed, setProcessSpeed] = useState({
        processedSeconds: 0,
        processedCount: 0,
        lastTime: null
    });

    const [tiposProcesos, setTiposProcesos] = useState([]);
    const [getListEntidad, , ready] = useEntidad({
        entidades: ['TipoProceso'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoProceso',
          timeout: 0
        }
    });
    useEffect(() => {
        if (ready) {
            setTiposProcesos(getListEntidad("TipoProceso"));
        }
    }, [ready]);

    const estadoEmisionEjecucionEstadoRef = useRef(0);

    const dispatch = useDispatch();
    const dataTagger = useSelector((state) => state.dataTagger.data);

    const [accessEmisionAprobacionView, setAccessEmisionAprobacionView] = useState(false);
    const [access, readyAceess] = useAccess({
        key: '_SecurityAccesses',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        }
    });
    useEffect(() => {
        if (readyAceess) {
            const emision_aprobacion_view = access.some(f => f.codigo === 'emision-aprobacion_view');
            setAccessEmisionAprobacionView(emision_aprobacion_view);
        }
    }, [readyAceess]);

    const {allowNavigation} = useUnsavedChangesGuard(pendingChange);

    const mount = () => {
        let myInterval = null;
        if (state.id > 0) {
            FindEmisionEjecucion();
            ListEmisionEjecucionCuentaResume();
            myInterval = setInterval(() => {
                if ([EMISION_EJECUCION_STATE.INICIADA, EMISION_EJECUCION_STATE.PROCESO].includes(estadoEmisionEjecucionEstadoRef.current)) {
                    ListEmisionEjecucionCuentaResume();
                }
            }, APPCONFIG.GENERAL.PROCESS_TIME_INTERVAL * 1000);
        } else {
            dispatch(dataTaggerActionSet(state.processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Ingrese los datos y presione siguiente para confirmar el alta');
        }

        return () => {
            if (myInterval) clearInterval(myInterval)
        };
    }
    useEffect(mount, []);

    useEffect(() => {
        if (state.entity.emisionEjecucion.idEstadoEmisionEjecucion > 0 && tiposProcesos.length > 0) SearchProcesos();
        estadoEmisionEjecucionEstadoRef.current = state.entity.emisionEjecucion.idEstadoEmisionEjecucion;
    }, [state.entity.emisionEjecucion.idEstadoEmisionEjecucion, tiposProcesos]);

    useEffect(() => {
        if (state.mode === OPERATION_MODE.EDIT && state.entity.emisionEjecucion.idEmisionDefinicion > 0) FindEmisionCuotas(state.entity.emisionEjecucion.idEmisionDefinicion);
    }, [state.entity.emisionEjecucion.idEmisionDefinicion]);

    useEffect(() => {
        if (listEmisionEjecucionCuentaResume.length > 0) {
            const today = getDateNow(true);
            const finalizados = listEmisionEjecucionCuentaResume.find(f => f.idEstadoEmisionEjecucionCuenta === 262) ?? {cantidad: 0};
            const erroneos = listEmisionEjecucionCuentaResume.find(f => f.idEstadoEmisionEjecucionCuenta === 264) ?? {cantidad: 0};
            if (finalizados.cantidad + erroneos.cantidad > 0) {
                if (processSpeed.lastTime) {
                    const seconds = (Math.abs(today - processSpeed.lastTime) / 1000);
                    const processedCount = (finalizados.cantidad + erroneos.cantidad - processSpeed.processedCount);
                    const processedSeconds = (seconds > 0 && processedCount > 0) ? (processedCount / seconds) : 0;
                    setProcessSpeed({
                        processedCount: finalizados.cantidad + erroneos.cantidad,
                        processedSeconds: processedSeconds.toFixed(0),
                        lastTime: today
                    });
                } else {
                    setProcessSpeed({
                        processedCount: finalizados.cantidad + erroneos.cantidad,
                        processedSeconds: 0,
                        lastTime: today
                    });
                }
            } else {
                setProcessSpeed({
                    processedCount: 0,
                    processedSeconds: 0,
                    lastTime: today
                });
            }
            const fecha1 = iif(state.entity.emisionEjecucion.fechaEjecucionInicio, null, "");
            const fecha2 = iif(listEmisionEjecucionCuentaResume[0].fechaEjecucionInicio, null, "");
            if (state.entity.emisionEjecucion.idEstadoEmisionEjecucion !== listEmisionEjecucionCuentaResume[0].idEstadoEmisionEjecucion ||
                fecha1.toString() !== fecha2.toString()) {
                FindEmisionEjecucion();
            }
        }
    }, [listEmisionEjecucionCuentaResume]);

    const [emisionEjecucion_formValues, emisionEjecucion_formHandle, , emisionEjecucion_formSet] = useForm({
        idEmisionDefinicion: 0,
        idEstadoEmisionEjecucion: 250, //Pendiente
        idEmisionEjecucionAdelantada: 0,
        numero: '',
        descripcion: '',
        descripcionAbreviada: '',
        descripcionNotificacion: '',
        periodo: '',
        imprimeRecibosEmision: false,
        aplicaDebitoAutomatico: false,
        calculoMostradorWeb: false,
        calculoMasivo: false,
        calculoPrueba: false,
        calculoPagoAnticipado: false,
        fechaPagoAnticipadoVencimiento1: null,
        fechaPagoAnticipadoVencimiento2: null,
        fechaEjecucionInicio: null,
        fechaEjecucionFin: null,
        idOrdenamientoGeneral: 0,
        cuota: 0
    }, 'emisionEjecucion_');

    let listVariables = useMemo(() =>
            getListVariables(state.entity.emisionVariables, state.entity.procedimiento),
        [timestampUpdateVariables]);

    const tableColumnsEmisionEjecucionCuentaResume = [
        {Header: 'Estado', accessor: 'estadoEmisionEjecucionCuenta', width: '60%'},
        {
            Header: 'Cantidad',
            Cell: (props) => getFormatNumber(props.value, 0),
            accessor: 'cantidad',
            width: '40%',
            alignCell: 'right',
            disableGlobalFilter: true,
            disableSortBy: true
        }
    ];
    //#endregion

    //handles
    const emisionEjecucion_formHandleProxy = (event) => {
        emisionEjecucion_formHandle(event);
        setPendingChange(true);
    }
    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickGuardar = () => {
        const errors = getErrors();
        if (errors.idEmisionDefinicion || errors.descripcion || errors.descripcionAbreviada) setDatosOpen(true);
        if (errors.fechaPagoAnticipadoVencimiento1 || errors.fechaPagoAnticipadoVencimiento2 || errors.cuota) setParametrosOpen(true);

        if (validate()) {
            if (state.id === 0) {
                AddEmisionEjecucion();
            } else {
                ModifyEmisionEjecucion();
            }
        }
        ;
    };
    const handleClickAction = (action) => {
        if (pendingChange) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "Existen cambios sin guardar.");
        }
        else {
            const actionMessage =   action === "init" ? "¿Desea iniciar la ejecución?" :
                                    action === "start" ? "¿Desea iniciar la ejecución?" :
                                    action === "stop" ? "¿Desea cancelar la ejecución?" :
                                    action === "recycle" ? "El siguiente proceso limpiará las cuentas con errores. ¿Desea continuar?" :
                                    action === "pause" ? "¿Desea pausar la ejecución?" :
                                    action === "continue" ? "¿Desea continuar con la ejecución?" : "";
            showMessageModal({
                title: "Confirmación",
                message: actionMessage,
                onConfirm: () => ModifyStateEmisionEjecucion(action),
            })
        }
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindEmisionEjecucion = (response) => {
        response.json()
            .then((data) => {

                if (data.emisionEjecucion.fechaPagoAnticipadoVencimiento1) data.emisionEjecucion.fechaPagoAnticipadoVencimiento1 = new Date(data.emisionEjecucion.fechaPagoAnticipadoVencimiento1);
                if (data.emisionEjecucion.fechaPagoAnticipadoVencimiento2) data.emisionEjecucion.fechaPagoAnticipadoVencimiento2 = new Date(data.emisionEjecucion.fechaPagoAnticipadoVencimiento2);
                if (data.emisionEjecucion.fechaEjecucionInicio) data.emisionEjecucion.fechaEjecucionInicio = new Date(data.emisionEjecucion.fechaEjecucionInicio);
                if (data.emisionEjecucion.fechaEjecucionFin) data.emisionEjecucion.fechaEjecucionFin = new Date(data.emisionEjecucion.fechaEjecucionFin);

                if (data.emisionAprobacion.fechaEmisionAprobacionCalculo) data.emisionAprobacion.fechaEmisionAprobacionCalculo = new Date(data.emisionAprobacion.fechaEmisionAprobacionCalculo);
                if (data.emisionAprobacion.fechaEmisionAprobacionControlRecibos) data.emisionAprobacion.fechaEmisionAprobacionControlRecibos = new Date(data.emisionAprobacion.fechaEmisionAprobacionControlRecibos);
                if (data.emisionAprobacion.fechaAprobacionCalculo) data.emisionAprobacion.fechaAprobacionCalculo = new Date(data.emisionAprobacion.fechaAprobacionCalculo);
                if (data.emisionAprobacion.fechaAprobacionControlRecibos) data.emisionAprobacion.fechaAprobacionControlRecibos = new Date(data.emisionAprobacion.fechaAprobacionControlRecibos);
                if (data.emisionAprobacion.fechaProcesoOrdenamiento) data.emisionAprobacion.fechaProcesoOrdenamiento = new Date(data.emisionAprobacion.fechaProcesoOrdenamiento);
                if (data.emisionAprobacion.fechaProcesoInformeOrdenamiento) data.emisionAprobacion.fechaProcesoInformeOrdenamiento = new Date(data.emisionAprobacion.fechaProcesoInformeOrdenamiento);
                if (data.emisionAprobacion.fechaAprobacionOrdenamiento) data.emisionAprobacion.fechaAprobacionOrdenamiento = new Date(data.emisionAprobacion.fechaAprobacionOrdenamiento);
                if (data.emisionAprobacion.fechaAprobacionCodigoBarras) data.emisionAprobacion.fechaAprobacionCodigoBarras = new Date(data.emisionAprobacion.fechaAprobacionCodigoBarras);
                if (data.emisionAprobacion.fechaProcesoCuentaCorriente) data.emisionAprobacion.fechaProcesoCuentaCorriente = new Date(data.emisionAprobacion.fechaProcesoCuentaCorriente);
                if (data.emisionAprobacion.fechaProcesoPublicacionDeuda) data.emisionAprobacion.fechaProcesoPublicacionDeuda = new Date(data.emisionAprobacion.fechaProcesoPublicacionDeuda);
                if (data.emisionAprobacion.fechaProcesoArchivoPublicacionDeuda) data.emisionAprobacion.fechaProcesoArchivoPublicacionDeuda = new Date(data.emisionAprobacion.fechaProcesoArchivoPublicacionDeuda);
                if (data.emisionAprobacion.fechaProcesoImpresion) data.emisionAprobacion.fechaProcesoImpresion = new Date(data.emisionAprobacion.fechaProcesoImpresion);
                if (data.emisionAprobacion.fechaProcesoNotificacion) data.emisionAprobacion.fechaProcesoNotificacion = new Date(data.emisionAprobacion.fechaProcesoNotificacion);

                data.emisionEjecucionCuotas.forEach(x => {
                    if (x.fechaVencimiento1) x.fechaVencimiento1 = new Date(x.fechaVencimiento1);
                    if (x.fechaVencimiento2) x.fechaVencimiento2 = new Date(x.fechaVencimiento2);
                    if (x.fechaVencimiento1Original) x.fechaVencimiento1Original = new Date(x.fechaVencimiento1Original);
                    if (x.fechaVencimiento2Original) x.fechaVencimiento2Original = new Date(x.fechaVencimiento2Original);
                    if (x.fechaVencimiento1Prorroga) x.fechaVencimiento1Prorroga = new Date(x.fechaVencimiento1Prorroga);
                    if (x.fechaVencimiento2Prorroga) x.fechaVencimiento2Prorroga = new Date(x.fechaVencimiento2Prorroga);
                });

                data.archivos.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.observaciones.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });

                setState(prevState => {
                    return {...prevState, loading: false, entity: data};
                });
                setTimestampUpdateVariables(new Date());
                setPendingChange(false);
                emisionEjecucion_formSet({
                    idEmisionDefinicion: data.emisionEjecucion.idEmisionDefinicion,
                    idEstadoEmisionEjecucion: data.emisionEjecucion.idEstadoEmisionEjecucion,
                    idEmisionEjecucionAdelantada: data.emisionEjecucion.idEmisionEjecucionAdelantada,
                    numero: data.emisionEjecucion.numero,
                    descripcion: data.emisionEjecucion.descripcion,
                    descripcionAbreviada: data.emisionEjecucion.descripcionAbreviada,
                    descripcionNotificacion: data.emisionEjecucion.descripcionNotificacion,
                    periodo: data.emisionEjecucion.periodo,
                    imprimeRecibosEmision: data.emisionEjecucion.imprimeRecibosEmision,
                    aplicaDebitoAutomatico: data.emisionEjecucion.aplicaDebitoAutomatico,
                    calculoMostradorWeb: data.emisionEjecucion.calculoMostradorWeb,
                    calculoMasivo: data.emisionEjecucion.calculoMasivo,
                    calculoPrueba: data.emisionEjecucion.calculoPrueba,
                    calculoPagoAnticipado: data.emisionEjecucion.calculoPagoAnticipado,
                    fechaPagoAnticipadoVencimiento1: data.emisionEjecucion.fechaPagoAnticipadoVencimiento1,
                    fechaPagoAnticipadoVencimiento2: data.emisionEjecucion.fechaPagoAnticipadoVencimiento2,
                    fechaEjecucionInicio: data.emisionEjecucion.fechaEjecucionInicio,
                    fechaEjecucionFin: data.emisionEjecucion.fechaEjecucionFin,
                    idOrdenamientoGeneral: data.emisionEjecucion.idOrdenamientoGeneral,
                    cuota: data.emisionEjecucion.cuota
                });
                dispatch(dataTaggerActionSet(state.processKey, {
                    Archivo: data.archivos,
                    Observacion: data.observaciones,
                    Etiqueta: data.etiquetas
                }));
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackSuccessListEmisionEjecucionCuentaResume = (response) => {
        response.json()
            .then((data) => {
                data.forEach(x => {
                    if (x.fechaEjecucionInicio) x.fechaEjecucionInicio = new Date(x.fechaEjecucionInicio);
                    if (x.fechaEjecucionFin) x.fechaEjecucionFin = new Date(x.fechaEjecucionFin);
                });
                setListEmisionEjecucionCuentaResume(data);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            });
    }
    const callbackSuccessFindEmisionCuotas = (response) => {
        response.json()
            .then((data) => {
                setListCuotas(data.emisionCuotas);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            });
    }
    const callbackSuccessSearchProcesos = (response) => {
        response.json()
        .then((data) => {
            data.sort((a,b) => b.id-a.id);

            const tipoProceso = tiposProcesos.find(f => f.codigo === 'EmisionEjecucionInicio');
            if (!tipoProceso) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, `Tipo de proceso no identificado: EmisionEjecucionInicio`);
                return;
            }

            let procesoEmisionEjecucionInicio = procesoInit;
            const procesosEmisionEjecucionInicio = data.filter(f => f.idTipoProceso === tipoProceso.id && f.idEntidad === state.id);
            if (procesosEmisionEjecucionInicio.length > 0) procesoEmisionEjecucionInicio = procesosEmisionEjecucionInicio[0]; //el más reciente

            if (state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.INICIADA &&
                [PROCESO_STATE.ERROR, PROCESO_STATE.CANCELADO, PROCESO_STATE.PAUSADO].includes(procesoEmisionEjecucionInicio.idEstadoProceso))
            {
                showMessageModal({
                    title: "Confirmación",
                    message: 'El proceso de inicio no pudo completarse y deberá ejecutarse nuevamente.',
                    onConfirm: () => ModifyStateEmisionEjecucion('stop'),
                })
            }
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        });
    }
    const callbackSuccessFindProcedimiento = (response) => {
        response.json()
            .then((data) => {

                let entity = CloneObject(state.entity);
                entity.procedimiento = data;
                setState(prevState => {
                    return {...prevState, loading: false, entity: entity};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }

    //funciones
    function getListVariables(emisionVariables, procedimiento) {
        return (procedimiento)
            ? procedimiento.procedimientoVariables
                .filter(f => emisionVariables.map(x => x.idProcedimientoVariable).includes(f.id))
                .sort((a, b) => a.orden - b.orden)
            : [];
    }

    function getErrors() {

        const errors = {};

        if (emisionEjecucion_formValues.idEmisionDefinicion === 0) errors.idEmisionDefinicion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (emisionEjecucion_formValues.descripcion.length === 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;
        if (emisionEjecucion_formValues.descripcionAbreviada.length === 0) errors.descripcionAbreviada = VALIDATION_MESSAGE.REQUIRED;

        if (emisionEjecucion_formValues.calculoPagoAnticipado) {
            if (emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento1 == null) errors.fechaPagoAnticipadoVencimiento1 = VALIDATION_MESSAGE.REQUIRED_DATE;
            if (emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento2 == null) errors.fechaPagoAnticipadoVencimiento2 = VALIDATION_MESSAGE.REQUIRED_DATE;
            if (emisionEjecucion_formValues.cuota <= 0) errors.cuota = 'Ingresá un número mayor a cero';
        }

        return errors;
    }

    function ListEmisionEjecucionCuentaResume() {

        const paramsUrl = `/resume/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_EJECUCION_CUENTA,
            paramsUrl,
            null,
            callbackSuccessListEmisionEjecucionCuentaResume,
            callbackNoSuccess,
            callbackError
        );

    }

    function FindEmisionCuotas(idEmisionDefinicion) {

        const paramsUrl = `/${idEmisionDefinicion}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_DEFINICION,
            paramsUrl,
            null,
            callbackSuccessFindEmisionCuotas,
            callbackNoSuccess,
            callbackError
        );

    }

    function SearchProcesos() {

        const paramsUrl = `/emision-ejecucion/${state.id}`;
    
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PROCESO,
            paramsUrl,
            null,
            callbackSuccessSearchProcesos,
            callbackNoSuccess,
            callbackError
        );
    
    }

    function FindProcedimiento(idProcedimiento) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/${idProcedimiento}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PROCEDIMIENTO,
            paramsUrl,
            null,
            callbackSuccessFindProcedimiento,
            callbackNoSuccess,
            callbackError
        );

    }

    function CleanProcedimiento() {
        let entity = CloneObject(state.entity);
        entity.procedimiento = entityInit.procedimiento;
        setState(prevState => {
            return {...prevState, loading: false, entity: entity};
        });
    }

    function FindEmisionEjecucion() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_EJECUCION,
            paramsUrl,
            null,
            callbackSuccessFindEmisionEjecucion,
            callbackNoSuccess,
            callbackError
        );

    }

    function AddEmisionEjecucion() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((row) => {
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Alta realizada correctamente", () => {
                        dispatch(dataTaggerActionClear(state.processKey));
                        setState(prevState => {
                            return {...prevState, loading: false};
                        });
                        allowNavigation();
                        navigate({
                            to: `/emision-ejecucion/${OPERATION_MODE.EDIT}/${row.emisionEjecucion.id}`,
                            refresh: true,
                            replace: true,
                        })
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const dataBody = {
            ...entityInit,
            emisionEjecucion: {
                ...state.entity.emisionEjecucion,
                idEmisionDefinicion: parseInt(emisionEjecucion_formValues.idEmisionDefinicion),
                idEstadoEmisionEjecucion: parseInt(emisionEjecucion_formValues.idEstadoEmisionEjecucion),
                idEmisionEjecucionAdelantada: parseInt(emisionEjecucion_formValues.idEmisionEjecucionAdelantada),
                numero: '', //es automatico
                descripcion: emisionEjecucion_formValues.descripcion,
                descripcionAbreviada: emisionEjecucion_formValues.descripcionAbreviada,
                descripcionNotificacion: emisionEjecucion_formValues.descripcionNotificacion,
                periodo: emisionEjecucion_formValues.periodo,
                imprimeRecibosEmision: emisionEjecucion_formValues.imprimeRecibosEmision,
                aplicaDebitoAutomatico: emisionEjecucion_formValues.aplicaDebitoAutomatico,
                calculoMostradorWeb: emisionEjecucion_formValues.calculoMostradorWeb,
                calculoMasivo: emisionEjecucion_formValues.calculoMasivo,
                calculoPrueba: emisionEjecucion_formValues.calculoPrueba,
                calculoPagoAnticipado: emisionEjecucion_formValues.calculoPagoAnticipado,
                fechaPagoAnticipadoVencimiento1: emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento1,
                fechaPagoAnticipadoVencimiento2: emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento2,
                fechaEjecucionInicio: emisionEjecucion_formValues.fechaEjecucionInicio,
                fechaEjecucionFin: emisionEjecucion_formValues.fechaEjecucionFin,
                idOrdenamientoGeneral: emisionEjecucion_formValues.idOrdenamientoGeneral,
                cuota: emisionEjecucion_formValues.cuota
            }
        };

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.EMISION_EJECUCION,
            null,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyEmisionEjecucion() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Actualización realizada correctamente", () => {
                dispatch(dataTaggerActionClear(state.processKey));
                callbackSuccessFindEmisionEjecucion(response);
            });
        };

        const dataBody = {
            ...entityInit,
            emisionEjecucion: {
                ...state.entity.emisionEjecucion,
                idEstadoEmisionEjecucion: parseInt(emisionEjecucion_formValues.idEstadoEmisionEjecucion),
                idEmisionEjecucionAdelantada: parseInt(emisionEjecucion_formValues.idEmisionEjecucionAdelantada),
                numero: emisionEjecucion_formValues.numero,
                descripcion: emisionEjecucion_formValues.descripcion,
                descripcionAbreviada: emisionEjecucion_formValues.descripcionAbreviada,
                descripcionNotificacion: emisionEjecucion_formValues.descripcionNotificacion,
                periodo: emisionEjecucion_formValues.periodo,
                imprimeRecibosEmision: emisionEjecucion_formValues.imprimeRecibosEmision,
                aplicaDebitoAutomatico: emisionEjecucion_formValues.aplicaDebitoAutomatico,
                calculoMostradorWeb: emisionEjecucion_formValues.calculoMostradorWeb,
                calculoMasivo: emisionEjecucion_formValues.calculoMasivo,
                calculoPrueba: emisionEjecucion_formValues.calculoPrueba,
                calculoPagoAnticipado: emisionEjecucion_formValues.calculoPagoAnticipado,
                fechaPagoAnticipadoVencimiento1: emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento1,
                fechaPagoAnticipadoVencimiento2: emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento2,
                fechaEjecucionInicio: emisionEjecucion_formValues.fechaEjecucionInicio,
                fechaEjecucionFin: emisionEjecucion_formValues.fechaEjecucionFin,
                idOrdenamientoGeneral: emisionEjecucion_formValues.idOrdenamientoGeneral,
                cuota: emisionEjecucion_formValues.cuota
            },
            archivos: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Archivo.filter(f => f.state !== 'o') : [],
            observaciones: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Observacion.filter(f => f.state !== 'o') : [],
            etiquetas: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Etiqueta.filter(f => f.state !== 'o') : [],
            emisionProcedimientoParametros: state.entity.emisionProcedimientoParametros.filter(f => f.state !== 'o'),
            emisionEjecucionCuotas: state.entity.emisionEjecucionCuotas //se envia completo por si hay que actualizar los vencimientos en el calculo pago anticipado
        };

        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.EMISION_EJECUCION,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyStateEmisionEjecucion(action) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Acción aplicada correctamente", () => {
                dispatch(dataTaggerActionClear(state.processKey));
                callbackSuccessFindEmisionEjecucion(response);
                ListEmisionEjecucionCuentaResume();
            });
        };

        const paramsUrl = `/${action}/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.EMISION_EJECUCION,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function UpdateEntity(typeEntity, row) {
        // o:original a:add m:modify r:remove c:modify only childs

        let entity = CloneObject(state.entity);

        if (typeEntity === 'EmisionEjecucionCuota') {
            if (row.state === 'a') {
                entity.emisionEjecucionCuotas.push(row);
            } else if (row.state === 'm') {
                const index = entity.emisionEjecucionCuotas.indexOf(entity.emisionEjecucionCuotas.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.emisionEjecucionCuotas[index] = row;
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.emisionEjecucionCuotas = entity.emisionEjecucionCuotas.filter(f => f.id !== row.id);
                } else {
                    let item = entity.emisionEjecucionCuotas.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        }

        setState(prevState => {
            return {
                ...prevState,
                entity: entity
            };
        });
        setPendingChange(true);
    }

    function UpdateEmisionProcedimientoParametro(rows) {
        // o:original a:add m:modify r:remove c:modify only childs

        let entity = CloneObject(state.entity);

        rows.forEach(row => {
            if (row.state === 'm') {
                const index = entity.emisionProcedimientoParametros.indexOf(entity.emisionProcedimientoParametros.find(x => x.id === row.id));
                if (index !== -1) {
                    entity.emisionProcedimientoParametros[index] = row;
                }
            }
        });

        setState(prevState => {
            return {
                ...prevState,
                entity: entity
            };
        });
        setPendingChange(true);
    }

    function IsEnabled(newEnabled, editEnabled) {
        return (
            (newEnabled && state.mode === OPERATION_MODE.NEW) ||
            (editEnabled && state.mode === OPERATION_MODE.EDIT && (
                    state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.PENDIENTE ||
                    state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.CANCELADA)
            )
        );
    }


    function SetTabActive(tab) {
        setState(prevState => {
            return {...prevState, tabActive: tab};
        });
    }

    return (
        <>

            <Loading visible={state.loading}></Loading>

            <SectionHeading
                titles={[
                    {title: 'Emisión'},
                    {title: 'Ejecución de emisiones', url: '/emision-ejecuciones'},
                    {title: params.mode === OPERATION_MODE.NEW ? 'Nueva' : `Número de emisión: ${emisionEjecucion_formValues.numero}`}
                ]}
            />

            <div className="m-top-20">

                <section className='section-accordion'>
                    <div className="m-top-20 m-bottom-20">
                        <Accordion title="Datos principales" open={datosOpen} onToggle={setDatosOpen}>
                            <div className='row form-basic'>
                                <div className="col-12 col-lg-5">
                                    <FormLabel htmlFor="emisionEjecucion_idEmisionDefinicion" required>Definición
                                        de emisión</FormLabel>
                                    <InputEntidad
                                        name="emisionEjecucion_idEmisionDefinicion"
                                        title="Definición de emisiones"
                                        tipName={TIPS.NAME.MODALS.DEFINICION_EMISIONES_MODAL}
                                        placeholder=""
                                        className={`form-control ${errorOf('idEmisionDefinicion') ? 'is-invalid' : ''}`}
                                        value={emisionEjecucion_formValues.idEmisionDefinicion}
                                        onChange={(event) => {
                                            const {target} = event;
                                            let idEmisionDefinicion = 0;
                                            let periodo = '';
                                            if (target.value > 0) {
                                                periodo = target.row.periodo;
                                                idEmisionDefinicion = target.row.id;
                                                FindProcedimiento(target.row.idProcedimiento);
                                            } else {
                                                CleanProcedimiento();
                                            }
                                            emisionEjecucion_formSet({
                                                ...emisionEjecucion_formValues,
                                                idEmisionDefinicion: idEmisionDefinicion,
                                                periodo: periodo
                                            });
                                            setPendingChange(true);
                                        }}
                                        disabled={!IsEnabled(true, false)}
                                        entidad="EmisionDefinicion"
                                        onFormat={(row) => (row && row.id) ? `${row.numero} - ${row.descripcion}` : ''}
                                        columns={[
                                            {Header: 'Número', accessor: 'numero', width: '20%'},
                                            {Header: 'Descripción', accessor: 'descripcion', width: '80%'},
                                        ]}
                                        memo={false}
                                    />
                                    <FormError message={errorOf('idEmisionDefinicion')} />
                                </div>
                                <div className="col-12 col-sm-6 col-lg-3">
                                    <FormLabel htmlFor="emisionEjecucion_descripcionAbreviada" required>Descripción
                                        abreviada</FormLabel>
                                    <input
                                        name="emisionEjecucion_descripcionAbreviada"
                                        type="text"
                                        placeholder=""
                                        maxLength={250}
                                        className={`form-control ${errorOf('descripcionAbreviada') ? 'is-invalid' : ''}`}
                                        value={emisionEjecucion_formValues.descripcionAbreviada}
                                        onChange={emisionEjecucion_formHandleProxy}
                                        disabled={!IsEnabled(true, true)}
                                    />
                                    <FormError message={errorOf('descripcionAbreviada')} />
                                </div>
                                <div className="col-12 col-sm-6 col-lg-2">
                                    <label htmlFor="emisionEjecucion_periodo" className="form-label">Período</label>
                                    <InputEjercicio
                                        name="emisionEjecucion_periodo"
                                        placeholder=""
                                        className="form-control"
                                        value={emisionEjecucion_formValues.periodo}
                                        onChange={emisionEjecucion_formHandleProxy}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-sm-6 col-lg-2">
                                    <label htmlFor="emisionEjecucion_numero" className="form-label">Número de
                                        emisión</label>
                                    <InputFormat
                                        name="emisionEjecucion_numero"
                                        placeholder="[automático]"
                                        className="form-control"
                                        mask={MASK_FORMAT.EMISION_NUMERO}
                                        maskPlaceholder={null}
                                        value={emisionEjecucion_formValues.numero}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-lg-5">
                                    <FormLabel htmlFor="emisionEjecucion_descripcion" required>Descripción</FormLabel>
                                    <input
                                        name="emisionEjecucion_descripcion"
                                        type="text"
                                        placeholder=""
                                        maxLength={1000}
                                        className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                        value={emisionEjecucion_formValues.descripcion}
                                        onChange={emisionEjecucion_formHandleProxy}
                                        disabled={!IsEnabled(true, true)}
                                    />
                                    <FormError message={errorOf('descripcion')} />
                                </div>
                                <div className="col-12 col-lg-5">
                                    <label htmlFor="emisionEjecucion_descripcionNotificacion"
                                           className="form-label">Descripción de notificación</label>
                                    <input
                                        name="emisionEjecucion_descripcionNotificacion"
                                        type="text"
                                        placeholder=""
                                        maxLength={250}
                                        className="form-control"
                                        value={emisionEjecucion_formValues.descripcionNotificacion}
                                        onChange={emisionEjecucion_formHandleProxy}
                                        disabled={!(state.mode === OPERATION_MODE.NEW || state.mode === OPERATION_MODE.EDIT)}
                                    />
                                </div>
                            </div>
                        </Accordion>

                        {(state.mode !== OPERATION_MODE.NEW) && (
                            <>
                                <div className="m-top-20">
                                    <Accordion title="Parámetros" open={parametrosOpen} onToggle={setParametrosOpen}>
                                        <div className='row form-basic'>
                                            <div className="col-12 col-md-auto">
                                                <CheckboxButtonGroup label="Tipo de cálculo">
                                                    <CheckboxButton
                                                        name="emisionEjecucion_calculoMostradorWeb"
                                                        label="Cálculo web"
                                                        checked={emisionEjecucion_formValues.calculoMostradorWeb}
                                                        onChange={emisionEjecucion_formHandleProxy}
                                                        disabled={true}
                                                    />
                                                    <CheckboxButton
                                                        name="emisionEjecucion_calculoMasivo"
                                                        label="Cálculo masivo"
                                                        checked={emisionEjecucion_formValues.calculoMasivo}
                                                        onChange={emisionEjecucion_formHandleProxy}
                                                        disabled={true}
                                                    />
                                                    <CheckboxButton
                                                        name="emisionEjecucion_calculoPrueba"
                                                        label="Cálculo de prueba"
                                                        checked={emisionEjecucion_formValues.calculoPrueba}
                                                        onChange={emisionEjecucion_formHandleProxy}
                                                        disabled={!IsEnabled(false, true)}
                                                    />
                                                </CheckboxButtonGroup>
                                            </div>
                                            <div className="col-12 col-md-auto">
                                                <CheckboxButtonGroup label="Opciones de emisión">
                                                    <CheckboxButton
                                                        name="emisionEjecucion_aplicaDebitoAutomatico"
                                                        label="Aplica débito automático"
                                                        checked={emisionEjecucion_formValues.aplicaDebitoAutomatico}
                                                        onChange={emisionEjecucion_formHandleProxy}
                                                        disabled={!IsEnabled(false, true)}
                                                    />
                                                    <CheckboxButton
                                                        name="emisionEjecucion_imprimeRecibosEmision"
                                                        label="Genera VEPs de emisión"
                                                        checked={emisionEjecucion_formValues.imprimeRecibosEmision}
                                                        onChange={emisionEjecucion_formHandleProxy}
                                                        disabled={((state.entity.emisionDefinicion.idBoletaDefinicion??0) > 0) || !IsEnabled(false, true)}
                                                    />
                                                </CheckboxButtonGroup>
                                            </div>
                                            <div className="col-12 col-md-auto">
                                                <CheckboxButtonGroup label="Pago anticipado">
                                                    <CheckboxButton
                                                        name="emisionEjecucion_calculoPagoAnticipado"
                                                        label="Aplica"
                                                        checked={emisionEjecucion_formValues.calculoPagoAnticipado}
                                                        onChange={() => {}}
                                                        disabled={true}
                                                    />
                                                </CheckboxButtonGroup>
                                            </div>
                                            <div className="w-100"></div>
                                            <div className="col-12 col-sm-6 col-lg-2">
                                                <FormLabel htmlFor="emisionEjecucion_fechaPagoAnticipadoVencimiento1" required={emisionEjecucion_formValues.calculoPagoAnticipado}>Primer vencimiento</FormLabel>
                                                <DatePickerCustom
                                                    name="emisionEjecucion_fechaPagoAnticipadoVencimiento1"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaPagoAnticipadoVencimiento1') ? 'is-invalid' : ''}`}
                                                    value={emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento1}
                                                    onChange={emisionEjecucion_formHandleProxy}
                                                    disabled={!emisionEjecucion_formValues.calculoPagoAnticipado || !IsEnabled(false, true)}
                                                />
                                                <FormError message={errorOf('fechaPagoAnticipadoVencimiento1')} />
                                            </div>
                                            <div className="col-12 col-sm-6 col-lg-2">
                                                <FormLabel htmlFor="emisionEjecucion_fechaPagoAnticipadoVencimiento2" required={emisionEjecucion_formValues.calculoPagoAnticipado}>Segundo vencimiento</FormLabel>
                                                <DatePickerCustom
                                                    name="emisionEjecucion_fechaPagoAnticipadoVencimiento2"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaPagoAnticipadoVencimiento2') ? 'is-invalid' : ''}`}
                                                    value={emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento2}
                                                    onChange={emisionEjecucion_formHandleProxy}
                                                    disabled={!emisionEjecucion_formValues.calculoPagoAnticipado || !IsEnabled(false, true)}
                                                    minValue={emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento1}
                                                />
                                                <FormError message={errorOf('fechaPagoAnticipadoVencimiento2')} />
                                            </div>
                                            <div className="col-12 col-sm-6 col-lg-2">
                                                <FormLabel htmlFor="emisionEjecucion_cuota" required={emisionEjecucion_formValues.calculoPagoAnticipado}>Cuota pago anticipado</FormLabel>
                                                <InputNumber
                                                    name="emisionEjecucion_cuota"
                                                    placeholder=""
                                                    precision={0}
                                                    className={`form-control ${errorOf('cuota') ? 'is-invalid' : ''}`}
                                                    value={emisionEjecucion_formValues.cuota}
                                                    onChange={emisionEjecucion_formHandleProxy}
                                                    disabled={!emisionEjecucion_formValues.calculoPagoAnticipado || !IsEnabled(false, true)}
                                                />
                                                <FormError message={errorOf('cuota')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="m-top-20">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de definición de emisión"
                                            processKey={state.processKey}
                                            entidad="EmisionEjecucion"
                                            idEntidad={state.id}
                                            disabled={state.mode !== OPERATION_MODE.EDIT}
                                            onChange={(row) => setPendingChange(true)}
                                        />
                                    </Accordion>
                                </div>
                            </>
                        )}

                        <Tabs
                            id="tabs-emision-ejecucion"
                            activeKey={state.tabActive}
                            className="m-top-20"
                            onSelect={(tab) => SetTabActive(tab)}
                        >
                            <Tab eventKey="procedimiento" title="Procedimiento">
                                <div className='tab-panel'>
                                    <div className='row form-basic'>
                                        <div className="col-12 col-lg-10 m-bottom-20">
                                            <label htmlFor="emisionEjecucion_idProcedimiento"
                                                   className="form-label">Procedimiento</label>
                                            <InputEntidad
                                                name="emisionEjecucion_idProcedimiento"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.procedimiento.id}
                                                disabled={true}
                                                entidad="Procedimiento"
                                                onFormat={(row) => (row && row.id) ? `${row.nombre} - ${row.descripcion}` : ''}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <ProcedimientoParametrosGrid
                                                disabled={!IsEnabled(false, true)}
                                                showValue={(state.mode !== OPERATION_MODE.NEW)}
                                                data={{
                                                    idEmisionEjecucion: state.id,
                                                    listParametros: (state.entity.procedimiento.id > 0)
                                                        ? state.entity.procedimiento.procedimientoParametros
                                                        : [],
                                                    listValores: state.entity.emisionProcedimientoParametros
                                                }}
                                                onChange={(typeEntity, rows) => UpdateEmisionProcedimientoParametro(rows)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="cuotas" title="Cuotas"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionEjecucionCuotasGrid
                                        disabled={!IsEnabled(false, true) || (emisionEjecucion_formValues.calculoPagoAnticipado && (!emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento1 || !emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento2))}
                                        data={{
                                            idEmisionEjecucion: state.entity.emisionEjecucion.id,
                                            periodo: state.entity.emisionDefinicion.periodo,
                                            listCuotas: listCuotas,
                                            listEjecucionCuotas: state.entity.emisionEjecucionCuotas,
                                            listVariables: listVariables,
                                            listFunciones: state.entity.funciones,
                                            fechaVencimiento1: (emisionEjecucion_formValues.calculoPagoAnticipado) ? emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento1 : null,
                                            fechaVencimiento2: (emisionEjecucion_formValues.calculoPagoAnticipado) ? emisionEjecucion_formValues.fechaPagoAnticipadoVencimiento2 : null
                                        }}
                                        periodo={state.entity.emisionDefinicion.periodo}
                                        procesaRubros={state.entity.emisionDefinicion.procesaRubros}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="ejecucion" title="Ejecución"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <div className='row form-basic'>
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <label htmlFor="resume_idEstadoEmisionEjecucion"
                                                   className="form-label">Estado</label>
                                            <InputLista
                                                name="resume_idEstadoEmisionEjecucion"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.emisionEjecucion.idEstadoEmisionEjecucion}
                                                disabled={true}
                                                lista="EstadoEmisionEjecucion"
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <label htmlFor="resume_fechaEjecucionInicio" className="form-label">Inicio
                                                ejecución</label>
                                            <input
                                                name="resume_fechaEjecucionInicio"
                                                type="text"
                                                className="form-control"
                                                value={getDateToString(state.entity.emisionEjecucion.fechaEjecucionInicio, true)}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <label htmlFor="resume_fechaEjecucionFin" className="form-label">Fin
                                                ejecución</label>
                                            <input
                                                name="resume_fechaEjecucionFin"
                                                type="text"
                                                className="form-control"
                                                value={getDateToString(state.entity.emisionEjecucion.fechaEjecucionFin, true)}
                                                disabled={true}
                                            />
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            {state.mode === OPERATION_MODE.EDIT && state.entity.emisionAprobacion.idEstadoAprobacionCalculo === 350 &&
                                                <>
                                                    <label className="form-label">Acciones de ejecución</label>
                                                    <div>
                                                        {state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.PENDIENTE &&
                                                            <button className="btn action-button no-m-left m-right-20"
                                                                    data-dismiss="modal"
                                                                    onClick={(event) => handleClickAction('init')}>Iniciar</button>
                                                        }
                                                        {(state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA ||
                                                          state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.PAUSADA) &&
                                                            <button
                                                                className="btn btn-outline-primary no-m-left m-right-20"
                                                                data-dismiss="modal"
                                                                onClick={(event) => handleClickAction('stop')}>Cancelar</button>
                                                        }
                                                        {(state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA ||
                                                          state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.PAUSADA) &&
                                                            listEmisionEjecucionCuentaResume.some(f => [261, 264].includes(f.idEstadoEmisionEjecucionCuenta)) &&
                                                            <button className="btn action-button no-m-left m-right-20"
                                                                    data-dismiss="modal"
                                                                    onClick={(event) => handleClickAction('recycle')}
                                                                    title='Las cuentas que no fueron procesadas correctamente las vuelve a estado pendiente'>Reciclar</button>
                                                        }
                                                        {state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.PROCESO &&
                                                            <button className="btn back-button no-m-left m-right-20"
                                                                    data-dismiss="modal"
                                                                    onClick={(event) => handleClickAction('pause')}>Pausar</button>
                                                        }
                                                        {state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.PAUSADA &&
                                                            <button className="btn action-button no-m-left m-right-20"
                                                                    data-dismiss="modal"
                                                                    onClick={(event) => handleClickAction('continue')}>Reanudar</button>
                                                        }
                                                        {(state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA ||
                                                          state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.CANCELADA ||
                                                          state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.PAUSADA) &&
                                                            <button className="btn action-button no-m-left m-right-20"
                                                                    data-dismiss="modal"
                                                                    onClick={(event) => handleClickAction('init')}>Reiniciar</button>
                                                        }
                                                    </div>
                                                </>
                                            }
                                        </div>

                                        <div className="w-100"></div>
                                        <div className="col-12 col-lg-6">
                                            <label className="form-label">Monitor de ejecución
                                                ({processSpeed.processedSeconds} cuentas/seg)</label>
                                            <TableCustom
                                                showFilterGlobal={false}
                                                className={'TableCustomBase'}
                                                columns={tableColumnsEmisionEjecucionCuentaResume}
                                                data={listEmisionEjecucionCuentaResume}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="resultadoCuenta" title="Resultados por cuenta"
                                 tabClassName={(state.mode !== OPERATION_MODE.NEW && state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionEjecucionCuentasGrid
                                        disabled={state.mode !== OPERATION_MODE.EDIT}
                                        data={{
                                            idCuenta: 0,
                                            idTipoTributo: state.entity.emisionDefinicion.idTipoTributo,
                                            emisionDefinicion: state.entity.emisionDefinicion,
                                            emisionEjecucion: state.entity.emisionEjecucion
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="aprobaciones" title="Aprobaciones"
                                 tabClassName={(accessEmisionAprobacionView && state.mode !== OPERATION_MODE.NEW && state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionAprobacionesGrid
                                        disabled={state.mode !== OPERATION_MODE.EDIT}
                                        data={{
                                            emisionEjecucion: state.entity.emisionEjecucion,
                                            emisionDefinicion: state.entity.emisionDefinicion,
                                            tiposProcesos: tiposProcesos
                                        }}
                                        onChange={() => FindEmisionEjecucion()}
                                        onProcessPendings={(count) => setCountProcessPendings(count)}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="procesos" title="Procesos"
                                 tabClassName={(accessEmisionAprobacionView && state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                                <div className='tab-panel'>
                                    <EmisionProcesosGrid
                                        disabled={state.mode !== OPERATION_MODE.EDIT}
                                        data={{
                                            emisionEjecucion: state.entity.emisionEjecucion,
                                            emisionDefinicion: state.entity.emisionDefinicion,
                                            emisionEjecucionCuotas: state.entity.emisionEjecucionCuotas,
                                            tiposProcesos: tiposProcesos
                                        }}
                                        countProcessPendings={countProcessPendings}
                                        onChange={() => FindEmisionEjecucion()}
                                    />
                                </div>
                            </Tab>
                        </Tabs>

                    </div>

                </section>

            </div>

            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <FooterButtonVolver
                        filters={filters}
                        to="/emision-ejecuciones"
                        pendingChange={pendingChange}
                        processKey={state.processKey}
                        allowNavigation={allowNavigation}
                    />
                    {state.mode !== OPERATION_MODE.VIEW &&
                        <button
                            className={pendingChange ? "btn action-button float-end" : "btn action-button btn-disabled float-end"}
                            onClick={(event) => handleClickGuardar()}
                            disabled={!pendingChange}
                        >
                            {(state.mode === OPERATION_MODE.NEW) ? "Siguiente" : "Guardar"}
                        </button>
                    }
                </div>
            </footer>

        </>
    )
}

export default EmisionEjecucionView;
